import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { useRoot } from 'context/RootContext';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, HTTP_VERBS, API_ENDPOINTS } from 'utils/constants';
import { usePath } from 'utils/hooks';

const useResendTickets = (screeningId, userId) => {
  const { showNotification } = useRoot();
  const queryString = `${API_ENDPOINTS.TICKETS}/screenings/${screeningId}/user/${userId}/resend`;
  const path = usePath(queryString);
  const { t } = useTranslation(LOCALIZATION_PAGES.USER_PROFILE);
  const [{ result, loading, error }, resendTickets] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.POST,
  });

  useEffect(() => {
    if (result) {
      showNotification({
        message: t('resend_tickets_success'),
      });
    }
  }, [result, showNotification, t]);

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('resend_tickets_failed'),
        },

        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  return [{ result, loading, error }, resendTickets];
};

export default useResendTickets;
